// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const latios_mega: PokeData = {
  "id": 10063,
  "name": "latios-mega",
  "height": 23,
  "weight": 700,
  "base_experience": 315,
  "types": [
    PokeType.DRAGON,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psychic",
    "recover",
    "psywave",
    "protect",
    "safeguard",
    "dragon-breath",
    "memento",
    "helping-hand",
    "refresh",
    "luster-purge",
    "dragon-dance",
    "psycho-shift",
    "heal-block",
    "dragon-pulse",
    "zen-headbutt",
    "power-split",
    "telekinesis",
    "stored-power",
    "heal-pulse"
  ],
  "moves": [
    "psychic",
    "psywave",
    "protect",
    "dragon-breath",
    "refresh",
    "dragon-dance",
    "dragon-pulse",
    "zen-headbutt",
    "inner-spirit",
    "dragon-fang",
    "prismatic-cage",
    "dragon-rush",
    "calm-mind"
  ],
  "evolution_chain": {
    "id": 197,
    "item": null,
    "species": [
      {
        "name": "latios",
        "order": 411,
        "types": [
          PokeType.DRAGON,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 104,
    "speed": 121,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
